import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  inject,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { MaterialModule } from '../../shared/material/material.module';
import { NotificationRef } from '../../core/generated';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthCustomService } from '../../security/auth-custom.service';
import { NotificationCountService } from '../../shared/services/notification-count.service';
import { NotificationStateService } from '../../shared/services/notification-state.service';
import { ContainerComponent } from '../../shared/container/container.component';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-notification',
    standalone: true,
    imports: [MaterialModule, ContainerComponent, RouterModule],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit, OnDestroy {
  private deviceService = inject(DeviceDetectorService);
  private cd = inject(ChangeDetectorRef);
  private authCustomService = inject(AuthCustomService);
  private notificationCountService = inject(NotificationCountService);
  private notificationStateService = inject(NotificationStateService);
  public router = inject(Router);

  isMobile = this.deviceService.isMobile();
  isLoading = false;

  @Output() toggleSideBarNotificationForMe: EventEmitter<any> =
    new EventEmitter();

  @Input()
  sidebarNotification: boolean = false;
  notificationsUnRead: NotificationRef[] = [];
  notificationsRead: NotificationRef[] = [];

  toggleSideBarNotification() {
    this.toggleSideBarNotificationForMe.emit();
    this.cd.detectChanges();
  }

  async ngOnInit() {
    this.isLoading = true;
    await this.notificationStateService.loadNotifications();
    this.isLoading = false;

    this.notificationStateService.notificationsUnRead$.subscribe(
      (notifications) => {
        this.notificationsUnRead = notifications;
        this.countNotification();
        this.cd.detectChanges();
      }
    );

    this.notificationStateService.notificationsRead$.subscribe(
      (notifications) => {
        this.notificationsRead = notifications;
        this.cd.detectChanges();
      }
    );

    const email = await this.authCustomService.userEmail;
    if (email) {
      await this.notificationStateService.initializeStream(email);
    } else {
      console.error('Email not available for notification stream');
    }
  }

  ngOnDestroy() {
    this.notificationStateService.closeStream();
  }

  async markAsRead(id: number) {
    await this.notificationStateService.markAsRead(id);
  }

  deleteNotification(id: number) {
    this.notificationStateService.deleteNotification(id);
  }

  countNotification(): number {
    if (!this.notificationsUnRead) {
      this.notificationCountService.updateCount(0);
      return 0;
    }
    const count = this.notificationsUnRead.length || 0;
    this.notificationCountService.updateCount(count);
    return count;
  }
}
